// extracted by mini-css-extract-plugin
module.exports = {"tabButton-color":"_32xoP","tabButtonColor":"_32xoP"};